import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";
import { httpRequest } from "../../http";

export class CommandForkAd {
    /**
     * Copy a locked ad's whole tree so its content can be edited. Returns the new ROOT of
     * the copy, not the counterpart of `adId` — the server forks from `ad.path[0]`
     * whichever ad in the tree you name.
     *
     * Pass adGroupId when editing inside an engagement: the copy then replaces the
     * original in that ad group (memberships re-point, published network links go
     * PENDING_ARCHIVE and republish onto the same deployment slot). Omit it to copy into
     * the content catalog only and leave every engagement pointing at the original.
     */
    async run(adId: number, adGroupId?: number): Promise<Ad> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/fork/`;
        try {
            const response = await httpRequest<any>(url, {
                method: "POST",
                body: adGroupId ? { ad_group_id: adGroupId } : {},
            });
            return new AdSerializer().deserialize(response);
        } catch (error) {
            console.error("Error forking ad:", error);
            throw error;
        }
    }
}
